import { useColors, useStyles } from "../ui";
import { pageNumbers } from "../utils";

export function Pagination({
  currentPage,
  totalPages,
  onPageChange,
}: {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}) {
  const styles = useStyles();
  const colors = useColors();

  if (totalPages <= 1) return null;

  const pageBtn = (active: boolean): React.CSSProperties => ({
    ...styles.btn,
    minWidth: "32px",
    fontWeight: active ? 700 : 400,
    background: active ? colors.primary : undefined,
    color: active ? "#fff" : undefined,
  });

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "2px",
        padding: "8px 0",
        flexShrink: 0,
        borderTop: `1px solid ${colors.border}`,
      }}
    >
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage <= 1}
        style={{ ...styles.btn, opacity: currentPage <= 1 ? 0.4 : 1 }}
      >
        {"\u2039"}
      </button>
      {pageNumbers(currentPage, totalPages).map((p, i) =>
        p === "..." ? (
          <span
            key={`e${i}`}
            style={{ padding: "0 4px", color: colors.textMuted }}
          >
            {"\u2026"}
          </span>
        ) : (
          <button
            key={p}
            onClick={() => onPageChange(p)}
            style={pageBtn(p === currentPage)}
          >
            {p}
          </button>
        ),
      )}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage >= totalPages}
        style={{ ...styles.btn, opacity: currentPage >= totalPages ? 0.4 : 1 }}
      >
        {"\u203A"}
      </button>
    </div>
  );
}
